import { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';
import { getGrillaPuesto } from '../../../../../../appStore/denominaciones';
import { useConcurso } from '../../../../../../providers/ConcursoProvider';
import LinkBtn from '../../../../../CompUtils/LinkBtn';
import { MenuOpcionesPuesto } from '../MenuOpcionesPuesto';
import { ModalCargaBasesYCondiciones } from './ModalCargaBasesYCondiciones';
import { usePuestoTableConfig } from './PuestosTableProvider';

export type PuestoProps = {
  idPuesto: number;
  ubicacionEstructural: string;
  denominacion: string;
  nivel: string;
  agrupamiento: string;
  reserva?: string;
  capacidadTerciaria?: string;
  funcionEspecifica: boolean;
  funcionEjecutiva: string;
  cantidad: number;
  pathPerfilPuesto: string;
  pathBbyccPuesto: string;
  requisitosCargados: boolean;
  idLlamadoConcurso: number;
};

type ColorTrProps = Partial<Record<'isComplete' | 'hasRequisitos' | 'hasPerfil', boolean>>;
const ColorTr = styled.tr<ColorTrProps>`
  color: 'blue';
  background-color: ${({ isComplete, hasPerfil, hasRequisitos }) =>
    isComplete
      ? 'lightgreen!important'
      : hasPerfil
      ? 'lightgoldenrodyellow!important'
      : hasRequisitos
      ? 'lightyellow!important'
      : undefined};
`;

export const PuestoRow = memo((puesto: PuestoProps) => {
  const { withActions, withBases, withGrilla, showBotonesActions } = usePuestoTableConfig();

  const dispatch = useDispatch();
  const { esCoordinadorConcursal, idLlamadoConcurso } = useConcurso();

  const {
    ubicacionEstructural,
    denominacion,
    nivel,
    agrupamiento,
    reserva,
    capacidadTerciaria,
    funcionEspecifica,
    cantidad,
    pathPerfilPuesto,
    pathBbyccPuesto,
    idPuesto,
    requisitosCargados,
  } = puesto;

  puesto = { ...puesto, idLlamadoConcurso: idLlamadoConcurso };

  const [showCargaBasesModal, setShowCargaBasesModal] = useState(false);
  function handleShowCargaBases() {
    setShowCargaBasesModal(!showCargaBasesModal);
  }

  return (
    <>
      <ColorTr
        isComplete={withActions && !!pathPerfilPuesto && !!requisitosCargados}
        hasPerfil={withActions && !!pathPerfilPuesto}
        hasRequisitos={withActions && !!requisitosCargados}>
        <td className="align-middle">
          <ReactTooltip place="left" delayShow={1000} />
          {ubicacionEstructural}
        </td>
        <td className="align-middle">{denominacion}</td>
        <td className="text-center align-middle">{nivel}</td>
        <td className="align-middle text-center">{agrupamiento}</td>
        <td className="align-middle text-center">{reserva ? 'X' : ''}</td>
        <td className="align-middle text-center">{capacidadTerciaria ? 'X' : ''}</td>
        <td className="align-middle text-center">{funcionEspecifica ? 'X' : ''}</td>
        <td className="text-center align-middle">{cantidad}</td>
        {showBotonesActions && (
          <td className="text-center align-middle">
            <MenuOpcionesPuesto
              withActions={withActions}
              idPuesto={idPuesto.toString()}
              pathPerfil={pathPerfilPuesto}
            />
          </td>
        )}
        {/* {withGrilla && esCoordinadorConcursal && (
          <td className="text-center align-middle">
            <LinkBtn
              transparent
              data-tip="Cargar grilla de ponderación"
              onClick={() => history.push('/concursos/cargagrilla', puesto)}>
              <i className="fa fa-lg fa-arrow-right text-muted" />
            </LinkBtn>
            <LinkBtn
              transparent
              data-tip="Ver"
              onClick={() => history.push('/concursos/vergrilla', puesto)}>
              <i className="fa fa-lg fa fa-file-text text-muted" />
            </LinkBtn>
          </td>
        )} */}
        {withGrilla && !esCoordinadorConcursal && (
          <td className="text-center align-middle">
            <LinkBtn
              transparent
              data-tip="Consultar grilla de ponderación"
              onClick={() => {
                dispatch(getGrillaPuesto({ idPuesto }));
              }}>
              <i className="fa fa-lg fa-file-text-o text-muted" />
            </LinkBtn>
          </td>
        )}
        {withBases && (
          <td className="text-center align-middle">
            <LinkBtn
              transparent
              data-tip="Generar bases y condiciones"
              onClick={() => {
                handleShowCargaBases();
              }}>
              <i className="fa fa-lg fa-file-text-o text-muted" />
            </LinkBtn>
          </td>
        )}
        <ModalCargaBasesYCondiciones
          idPuesto={idPuesto}
          pathBases={pathBbyccPuesto}
          withActions={withActions}
          showCargaBasesModal={showCargaBasesModal}
          handleCloseModal={() => handleShowCargaBases()}></ModalCargaBasesYCondiciones>
      </ColorTr>
    </>
  );
});
